const styles = {
  root: {
    height: "35px",
    "& .MuiOutlinedInput-root": {
      color: "green.dark",
      backgroundColor: "white",
      borderRadius: 4,
      height: "35px",
      padding: "0 4px",
    },
  },
};
export default styles;
